import { render, staticRenderFns } from "./IntervinienteForm.vue?vue&type=template&id=275ace16&scoped=true"
import script from "./IntervinienteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./IntervinienteForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IntervinienteForm.vue?vue&type=style&index=0&id=275ace16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275ace16",
  null
  
)

export default component.exports